export const EmbeddedConfigText = 'Embedding Config';
export const AddProviderText = 'Add Provider';
export const ProviderNameText = 'Provider Name';
export const ProviderKeyText = 'Provider API Key';
export const ModelNameText = 'Model Name';
export const PromptTokenText = 'Prompt token cost (per million token)';
export const DescriptionText = 'Description';
export const AddProviderDesc = 'Add Provider to the system';
